import { render, staticRenderFns } from "./LineChart.vue?vue&type=template&id=f00ab88a&scoped=true"
import script from "./LineChart.vue?vue&type=script&lang=js"
export * from "./LineChart.vue?vue&type=script&lang=js"
import style0 from "./LineChart.vue?vue&type=style&index=0&id=f00ab88a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00ab88a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f00ab88a')) {
      api.createRecord('f00ab88a', component.options)
    } else {
      api.reload('f00ab88a', component.options)
    }
    module.hot.accept("./LineChart.vue?vue&type=template&id=f00ab88a&scoped=true", function () {
      api.rerender('f00ab88a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chartjs/LineChart.vue"
export default component.exports